export default function alphabetizeBy(property, arr) {
  return arr.sort((a, b) => {
    if (a[property] < b[property]) {
      return -1
    }
    if (a[property] > b[property]) {
      return 1
    }
    return 0
  })
}



// WEBPACK FOOTER //
// ./src/helpers/alphabetizeBy.js